import React, { Component } from "react";
import { Link } from "react-router";
import Content from "./Content";
import getPath from "../../../shared/utils/getPath";

export default class ProjectPage extends Component {
  /* eslint-disable max-len */
  render() {
    return (
      <Content>
        <div className="imprint">
          <h1>Impressum & Datenschutz</h1>
          <h2>Impressum</h2>
          <h3>Angaben gemäß § 5 Telemediengesetz - TMG:</h3>
          <br />
          Herausgeber
          <br />
          <br />
          Bezirk Oberfranken
          <br />
          Cottenbacher Straße 23
          <br />
          95445 Bayreuth
          <br />
          <br />
          Postanschrift:
          <br />
          Postfach 101152
          <br />
          95411 Bayreuth
          <br />
          <br />
          Telefon: 0921 7846-0
          <br />
          Fax: 0921 7846-90
          <br />
          <br />
          E-Mail: info@bezirk-oberfranken.de
          <br />
          <br />
          Der Bezirk Oberfranken ist als kommunale Gebietskörperschaft eine
          juristische Person des öffentlichen Rechts (Art. 1 Abs. 1
          Bezirksordnung – BezO). Er wird vertreten durch den
          Bezirkstagspräsidenten Henry Schramm.
          <br />
          Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz: DE
          1323 67 124
          <br />
          <br />
          <h3>
            Verantwortlich für den Inhalt nach § 55 Abs. 2 Rundfunkstaatsvertrag
            - RStV
          </h3>
          <br />
          Pressesprecher des Bezirks Oberfranken
          <br />
          Florian Bergmann
          <br />
          Cottenbacher Straße 23
          <br />
          95445 Bayreuth
          <br />
          <br />
          Telefon: 0921 7846-3003
          <br />
          Fax: 0921 7846-4 3003
          <br />
          <br />
          <h3>Konzeption</h3>
          <br />
          Nicole Fleischer, Bezirk Oberfranken
          <br />
          <br />
          <h3>Administration</h3>
          <br />
          KulturServiceStelle des Bezirks Oberfranken
          <br />
          Tina Miehe
          <br />
          Adolf-Wächter-Straße 17
          <br />
          95447 Bayreuth
          <br />
          <br />
          Telefon: 0921 7846-1437
          <br />
          Fax: 0921 7846-4 1437
          <br />
          <br />
          <h3>Programmierung</h3>
          <br />
          Simon Schmidt
          <br />
          <a href="http://www.alarie.de">http://www.alarie.de</a>
          <br />
          <br />
          <h3>Haftung für Inhalte</h3>
          <br />
          Als Diensteanbieter sind wir gemäß § 7 Abs. 1 TMG für eigene Inhalte
          auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach
          §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht
          verpflichtet, übermittelte oder gespeicherte fremde Informationen zu
          überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige
          Tätigkeit hinweisen.
          <br />
          Verpflichtungen zur Entfernung oder Sperrung der Nutzung von
          Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt.
          Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der
          Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden
          von entsprechenden Rechtsverletzungen werden wir diese Inhalte
          umgehend entfernen.
          <br />
          <br />
          <h3>Haftung für Links</h3>
          <br />
          Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren
          Inhalte wir keinen Einfluss haben. Deshalb können wir für diese
          fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der
          verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der
          Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der
          Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige
          Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar.
          <br />
          Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch
          ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei
          Bekanntwerden von Rechtsverletzungen werden wir derartige Links
          umgehend entfernen.
          <br />
          <br />
          <h3>Nutzungsbedingungen</h3>
          <br />
          Die durch den Bezirk Oberfranken erstellten Texte, Bilder und Grafiken
          auf diesen Seiten sowie die Gestaltung dieser Internetseiten
          unterliegen dem deutschen Urheberrecht. Sie dürfen von Ihnen nur zum
          privaten und sonstigen eigenen Gebrauch im Rahmen des § 53
          Urheberrechtsgesetz (UrhG) verwendet werden. Eine Vervielfältigung
          oder Verwendung dieser Seiten oder Teilen davon in anderen
          elektronischen oder gedruckten Publikationen und deren
          Veröffentlichung ist nur mit unserer vorherigen ausdrücklichen
          Zustimmung gestattet. Diese erteilt auf Anfrage der für den Inhalt
          Verantwortliche. Weiterhin können Texte, Bilder, Grafiken und sonstige
          Dateien ganz oder teilweise dem Urheberrecht Dritter unterliegen. Auch
          über das Bestehen möglicher Rechte Dritter gibt Ihnen der für den
          Inhalt Verantwortliche nähere Auskünfte. Der Nachdruck und die
          Auswertung von Pressemitteilungen und Reden sind mit Quellenangabe
          allgemein gestattet.
          <br />
          <br />
          <h2>
            <Link to={getPath("frontend", "dsgvo")}>Datenschutz</Link>
          </h2>
        </div>
      </Content>
    );
    /* eslint-enable max-len */
  }
}



// WEBPACK FOOTER //
// ./src/frontend/base/components/ImprintPage.js